import { IconUserCheck } from '@iwoca/icons';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { TIntroducerListItem } from '../UsersTable.types';
import styles from './NameCell.module.css';

type TProps = { user: TIntroducerListItem };

export const NameCell = ({ user }: TProps) => {
  const { introducer } = useIntroducerData();
  const isCurrentUser = introducer?.id === user.id;

  return (
    <div className={styles.cell}>
      <div className={styles.nameRow}>
        <span className={styles.name}>
          {`${user.first_name} ${user.last_name}`}
        </span>
        {isCurrentUser && <span className={styles.youTag}>You</span>}
      </div>
      {user.master_broker && (
        <span className={styles.role}>
          <IconUserCheck className={styles.roleIcon} aria-hidden />
          Master broker
        </span>
      )}
    </div>
  );
};
